module.exports = __webpack_public_path__ + "img/icon-facts.76ce9dc7.png";